
import { h, Fragment } from 'jsx-dom'
import { onScrollTo } from './../utility/onScrollTo'
import { tns } from 'tiny-slider/src/tiny-slider'

const jsonScript = id => document.querySelector(id) && JSON.parse(document.querySelector(id).textContent) || null

const stripTags = html => {
  const doc = new DOMParser().parseFromString(html, 'text/html')
  return doc.body.textContent || ''
}

const json = (url, callback = () => {}) => {
	if (!url) callback(null)
	const request = new XMLHttpRequest()
	request.addEventListener('readystatechange', event => {
		if (request.readyState !== 4) return
	    if (request.status == 200) return callback(JSON.parse(request.responseText))
		return callback(null)
	})
    request.open("GET", url, true)
    request.send(null)
}

const limit = (string, length = 100) => {
	if (string.length <= length) return string
	return string.substring(0, length).trim() + '…'
}

const CuratorPost = (post) => {

	const {
		text, 
		url, 
		user_url,
		user_screen_name,
		network_id,
		network_name
	} = post

	const images = [post.image, post.image_large, post.thumbnail].filter(Boolean)
	const showNetworkIcon = ['instagram', 'twitter', 'facebook', 'linkedin', 'tiktok'].indexOf(network_name.toLowerCase()) > -1
	const networkIconClass = `inline-block vertical-middle margin-right-1 icon icon--${network_name.toLowerCase()}-black`

	const errorHandler = event => {
		const newImage = images.shift()		
		if (newImage) {
			event.currentTarget.src = newImage
		} else {
			event.currentTarget.style.display = 'none'
		}
	}

	return <>
		<div class="image-square">
			<a target="_blank" href={url}><img class="object-fit--absolute" src={images.shift()} onerror={errorHandler} /></a>
		</div>
		<div class="padding-top-2 padding-right-1">
			<a target="_blank" href={user_url} class="text-black bold a-underline-hover">
				{showNetworkIcon && <div class={networkIconClass}></div>}
				{user_screen_name}
			</a>
			<p class="margin-top-1">{limit(stripTags(text))}</p>
		</div>
	</>
}

const onScrollToHandler = el => {

	const key = (el.getAttribute('data-social-feed-curator-id') || '').trim()
	if (!key) return

	const curatorPosts = new Promise((resolve, reject) => {
		json(`https://api.curator.io/v1/feeds/${key}/posts`, response => {
			if (!response) reject()
			const latest = response.posts.filter(post => {
				return !post.is_deleted && (post.image || post.image_large || post.thumbnail)
			})
			resolve(latest)
		})
	})

	curatorPosts.then(curatorPosts => {

		const allPosts = curatorPosts.map(post => ({ type : 'curator', date : post.source_created_at, ...post }))

		const latestPosts = allPosts
			.sort((a, b) => (a.date < b.date) ? 1 : -1)
			.slice(0, 20)

		const carousel = <div class="carousel__inner">
			{latestPosts.map(post => {
				return <div><CuratorPost {...post} /></div>
			})}
		</div>
		
		tns({
			container: el.appendChild(carousel),
			items: 1,
			controls : true,
			controlsPosition: 'bottom',
			navPosition: 'bottom',
			touch: true,
			mouseDrag: true,
			responsive : {
				450 : { items : 2, nav : false },
				860 : { items : 3 },
			}
		})
	})	
}

const init = () => onScrollTo("[data-social-feed-curator-id]", onScrollToHandler, {offset : 1000})

export default init

